import { Component, Input } from '@angular/core';


@Component({
    selector: 'm-tooltip',
    imports: [],
    templateUrl: './modern-tooltip.component.html',
    styleUrl: './modern-tooltip.component.scss'
})
export class ModernTooltipComponent {

    @Input() position: { x: number, y: number } = { x: 0, y: 0 };
    @Input() content: string = '';
    @Input() imageUrl: string = '';

}
